



























import Enumerable from "linq";
import { Component, Mixins, Watch, Emit } from "vue-property-decorator";
import { StandardOption, MultiOptionSelectableMixin } from "./mixins";
import MultiListBoxSelector from "../../system/selectors/MultiListBoxSelector.vue";

@Component({
  components: {
    MultiListBoxSelector,
  },
})
export default class OrderableOptionListBoxSelector extends Mixins(MultiOptionSelectableMixin) {
  data(): any {
    return {
      selectingSelectedOptions: [],
    };
  }
  selectingSelectedOptions: StandardOption<any>[];

  // optionのclickイベントはIEでは動作しない...(chromeはイケた.)回避策として選択変更時に増えてる物をクリックされたと見なす.
  @Watch("selectingOptions")
  onSelectingOptionsChanged(newValue: StandardOption<any>[], oldValue: StandardOption<any>[]): void {
    this.notifyClicked(newValue, oldValue);
  }

  @Watch("selectingSelectedOptions")
  onSelectingSelectedOptions(newValue: StandardOption<any>[], oldValue: StandardOption<any>[]): void {
    this.notifyClicked(newValue, oldValue);
  }

  private notifyClicked(newValue: StandardOption<any>[], oldValue: StandardOption<any>[]): void {
    const clicked = Enumerable.from(newValue).firstOrDefault(o => (oldValue.indexOf(o) < 0));
    if (clicked) {
      this.clicked(clicked.value);
    }
  }

  @Emit()
  clicked(clicked: any): void {}

  @Emit()
  dblclick(e: PointerEvent): void {}

  get hasSelectingSelectedOptions(): boolean {
    return (0 < this.selectingSelectedOptions.length);
  }

  get isMovableToPrevious(): boolean {
    return this.isMovable(-1);
  }

  get isMovableToPost(): boolean {
    return this.isMovable(1);
  }

  areOptionsEqual(source: StandardOption<any>, destination: StandardOption<any>): boolean {
    return (source === destination)
        || (source && destination && this.areEqual(source.value, destination.value));
  }
  
  isMovable(amount: number): boolean {
    return (this.adjustAmount(amount, this.selectingSelectedOptions, this.options) !== 0);
  }

  moveSelection(amount: number): void {
    // 先にループを回してindexがはみ出さないようamountを調整しておく.
    const adjustedAmount = this.adjustAmount(amount, this.selectingSelectedOptions, this.options);
    const results = this.selectedOptions.concat();
    const selecting = this.selectingSelectedOptions.concat();
    // 向きによって処理順を変える.(追い抜きによってずれるのを防ぐため.)
    Enumerable.from((0 < adjustedAmount) ? selecting.reverse() : selecting)
      .forEach(o => {
        const index = Enumerable.from(results).indexOf(s => this.areOptionsEqual(s, o));
        results.splice(index, 1);
        results.splice(index + adjustedAmount, 0, o);
      });
    this.selectedOptions = results;
  }

  adjustAmount(amount: number, selecting: StandardOption<any>[], selected: StandardOption<any>[]): number {
    if ((selecting.length <= 0) || (selected.length <= 0)) {
      return 0;
    }
    const indexes = Enumerable.from(selecting)
      .select(o => Enumerable.from(selected).indexOf(s => this.areOptionsEqual(s, o)))
      .toArray();
    const min = Enumerable.from(indexes).min();
    const max = Enumerable.from(indexes).max();
    return ((min + amount) < 0)
      ? -min
      : ((selected.length <= (max + amount)) ? (amount - (selected.length - max)) : amount);
  }
}
